namespace advisorop.components.advisor {

    export class PopHhrSleevesController {
        // bindings
        accountId: number;
        
        static $inject = ["advisorService", "generalService","$uibModal"];
        constructor(
            private advisorService: advisorop.services.AdvisorService,
            private generalService: advisorop.services.GeneralService,
            private $uibModal: angular.ui.bootstrap.IModalService
        ) {
        }
        


        // loading methods
        
        // overrides
        $onChanges(evt): void {
            //{ currentValue, previousValue, isFirstChange() }   
            for (var key in evt) {
                //if (key == "accountId" && this.accountId > 0) {
                //} else if (key == "investor" && this.investor.id > 0) {
                //}
            }
        }

        $onInit(): void {
        }
    }

    class PopHhrSleeves implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                accountId: "<",
                investor: "<",
                documentType: "<",
            };
            this.controller = PopHhrSleevesController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/pop-hhr-sleeves.html";
        }
        
    }
    angular.module(Constants.APP).component("popHhrSleeves", new PopHhrSleeves());
}